import { FC, Fragment } from "react";
import { TeamContext } from "../../../types/common";

const SITE_ROOT = process.env.REACT_APP_SITE_ROOT_URL;

interface ClubLinksProps {
    teamName?: TeamContext;
}

export const ClubLinks: FC<ClubLinksProps> = ({
    teamName
}) => {
    const linkItems = [];

    if (teamName !== TeamContext.RODINA) {
        linkItems.push({
            href: 'https://fcrodina.com',
            label: 'ФК «Родина»'
        });
    }

    /*if (teamName !== TeamContext.RODINA_2) {
        linkItems.push({
            href: '/rodina-2/',
            label: 'Родина-2'
        });
    }

    if (teamName !== TeamContext.RODINA_3) {
        linkItems.push({
            href: '/rodina-3/',
            label: 'Родина-3'
        });
    }*/

    if (teamName !== TeamContext.RODINA_M) {
        linkItems.push({
            href: 'https://academy.fcrodina.com/youth/',
            label: 'Молодёжка'
        });
    }

    if (teamName !== TeamContext.ACADEMY) {
        linkItems.push({
            href: 'https://academy.fcrodina.com/',
            label: 'Академия «Родина»'
        });
    }

    return (
        <div className="flex justify-center items-center space-x-2">
            {linkItems.map((item, index) => (
                <Fragment key={index}>
                    <a href={item.href} className="transition-all px-2 rounded text-white hover:text-sky-500 text-xl hover:bg-sky-950 no-underline hover:no-underline">{item.label}</a>
                    {index < linkItems.length - 1 && <span className="text-white text-xl">·</span>}
                </Fragment>
            ))}
        </div>
    );
}